import { Button } from "react-bootstrap";
import { useHrStyles } from "../../Context/HRContext";
import "./ComText.css";

export default function ComText() {
  const hrStyles = useHrStyles();
  return (
    <div className="res-text-container">
      <p
        style={{
          textAlign: "justify",
          fontSize: "1em",
          paddingLeft: "1em",
          paddingRight: "1em",
          fontFamily: "'Inria Serif', serif",
          padding: "0% 20%",
          paddingTop: "2em",
        }}
      >
        At BEAMS, we specialize in designing and constructing innovative
        commercial buildings that meet the diverse needs of businesses. Whether
        it’s a retail space, office building, or industrial facility, our team
        delivers functional and aesthetically pleasing designs that align with
        your business objectives. We focus on creating spaces that enhance
        productivity, foster collaboration, and leave a lasting impression. By
        incorporating cutting-edge materials and sustainable practices, we
        ensure that every commercial project is built to last, serving as a
        solid foundation for your business’s success.
      </p>
      <Button
        href="/Contact"
        variant="outline-primary"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
      <div style={{ marginTop: "20px" }}></div>
    </div>
  );
}
